import createCache from '@emotion/cache';

export default function EmotionCache() {
  return createCache({ key: 'css' });
}
